import React, { useEffect } from "react";
import Navbar from "../Navigation/Navigation";
import Footer from "../Footer/Footer";
import RelatedWorks from "./RelatedWorks";
import "./Mgrdetail.css";

export default function SwathyDetails() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="work-detail-page">
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', zIndex: 1000 }}>
        <Navbar />
      </div>

      <section className="project-info-section">
        <h1 className="project-title-heading">
          Swathy Foundation
        </h1>

        <p className="project-description">
          We designed and developed a comprehensive brand presence for Swathy, delivering premium outdoor billboard designs, corporate product brochures, and a modern, responsive website. Our creative approach focused on capturing Swathy's brand legacy and presenting their offerings through structured, visually-rich layouts, ensuring seamless online and offline customer engagement.
        </p>

        <div className="project-tags">
          <span className="info-tag">Brand Identity</span>
          <span className="info-tag">Website Design</span>
          <span className="info-tag">Brochure Design</span>
        </div>
      </section>

      {/* Full landscape video */}
      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Swathy/Full3.webp" alt="Swathy Branding Showcase" />
      </div>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "We built a responsive, modern website for Swathy, focusing on clean user experiences, seamless menu navigation, and appetizing food photography to elevate their digital identity."
        </div>
      </section>



      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Swathy/Full1.webp" alt="Swathy Branding Showcase" />
      </div>

      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Swathy/Full4.webp" alt="Swathy Branding Showcase" />
      </div>
      {/* Quote text below the billboard images */}
      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "We designed grand-scale outdoor billboards for Swathy, engineered to capture attention on key transport routes with clean typography, vibrant brand imagery, and strong local presence."
        </div>
      </section>


      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Swathy/Full2.webp" alt="Swathy Branding Showcase" />
      </div>


      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "Our team crafted a premium, high-quality brochure system for Swathy, translating their history and traditional products into a beautifully structured, tactile print layout."
        </div>
      </section>

      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Swathy/Full5.webp" alt="Swathy Branding Showcase" />
      </div>


      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "Our team crafted a premium, high-quality brochure system for Swathy, translating their history and traditional products into a beautifully structured, tactile print layout."
        </div>
      </section>

        <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Swathy/Full6.webp" alt="Swathy Branding Showcase" />
      </div>


      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "Our team crafted a premium, high-quality brochure system for Swathy, translating their history and traditional products into a beautifully structured, tactile print layout."
        </div>
      </section>

      

      <RelatedWorks excludePath="/works/swathy" />
      <Footer />
    </div>
  );
}
